exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tag-c[data-v-40fd5c2a] {\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  overflow: hidden;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-40fd5c2a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ChatBot/organisms/ChatBotTags.vue
// module id = D3Ra
// module chunks = 0